import React from "react";
import { Col, Row, Typography } from "antd";
import BitItem from "@components/BitResults/components/BitItem";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getHistoryBid } from "dataLayer/product";

const { Title } = Typography;

const BitResults = ({ product }) => {
  const { t } = useTranslation();
  const { data } = useQuery(getHistoryBid([product?.cp_id], 1, "desc", 4));
  return (
    <div className="results-item-bid">
      <Title level={2} className="results-page-bid">{t("bid.history")}</Title>
      <Row gutter={[0, { xs: 15, sm: 15, lg: 15, xl: 25 }]}>
        {data?.data?.map((history, index) => (
          <Col xs={24} key={index}>
            <BitItem history={history} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default BitResults;

